import type { RouteRecordRaw } from 'vue-router';
import { RouterView } from 'vue-router';

export const wmsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../pages/_layout/WmsLayout.vue'), // enthält <RouterView/>
    children: [
      { path: '', name: 'home', component: () => import('../pages/Dashboard.vue') },

      {
        path: 'ref/articles',
        component: RouterView,
        children: [
          { path: '', name: 'wms.articles', component: () => import('../pages/refArticles/RefArticleView.vue') },
          { path: 'details/:id', name: 'wms.articles.details', component: () => import('../pages/refArticles/DetailsRefArticleView.vue'), props: true },
          { path: 'units', name: 'wms.articles.units', component: () => import('../pages/refArticles/RefUnitView.vue') },
        ],
      },

      {
        path: 'stock',
        component: RouterView,
        children: [
          { path: '', name: 'wms.stock', component: () => import('../pages/stocks/StockView.vue') },
          { path: 'details/:id', name: 'wms.stock.details', component: () => import('../pages/stocks/StockDetailsView.vue'), props: true },
        ],
      },

      {
        path: 'inventory-counts',
        component: RouterView,
        children: [
          { path: '', name: 'wms.inventory-counts', component: () => import('../pages/inventoryCounts/InventoryCountView.vue') },
          {
            path: 'details/:id',
            name: 'wms.inventory-counts.details',
            component: () => import('../pages/inventoryCounts/InventoryCountDetailsView.vue'),
            props: true,
          },
        ],
      },

      {
        path: 'activity',
        name: 'wms.activity',
        component: () => import('../pages/activity/ActivityTimelineView.vue'),
        meta: { requiresWmsAdmin: true },
      },

      // Tags
      { path: 'ref/tags', name: 'wms.tags', component: () => import('../pages/refTags/RefTagView.vue') },

      // Warehouses
      {
        path: 'warehouses',
        component: RouterView,
        children: [
          { path: '', name: 'wms.warehouses', component: () => import('../pages/wh/warehouses/WarehouseView.vue') },
          { path: 'details/:id', name: 'wms.warehouses.details', component: () => import('../pages/wh/warehouses/DetailsWarehouseView.vue'), props: true },
        ],
      },
    ],
  },
];
